import { render, staticRenderFns } from "./BaseModalGallery.vue?vue&type=template&id=5f009290&"
import script from "./BaseModalGallery.vue?vue&type=script&lang=js&"
export * from "./BaseModalGallery.vue?vue&type=script&lang=js&"
import style0 from "./BaseModalGallery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports